exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".extraButton[data-v-8c7df506]{cursor:pointer;width:50px;height:50px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;background-color:#fff;border-radius:30px;border:hidden;transition:box-shadow .2s ease-out}.extraButton[data-v-8c7df506]:hover{box-shadow:0 0 10px rgba(0,0,0,.8)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c7df506","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/uikit/components/AppDefaultLayout/components/parts/extra_buttons/ExtraButton.vue
// module id = 273de7e1acaf306002d8
// module chunks = 0